import type {ReactElement} from 'react';
import React, {useState} from 'react';
import {Thumbnail} from '@Components/thumbnail';
import {ThumbnailType} from '@Components/thumbnail/thumbnail.types';
import {IconShape, IconSize} from '@Components/icon-v2/icon.types';
import {getAssetUrl} from '@Utils/s3.util';
import {ThumbNailType} from '@Panels/poster-publishing-options-panel/poster-publishing-options-panel.types';
import {CircularProgressLoader, LOADER_COLOR, LOADER_SIZE} from '@Components/circular-progress-loader';
import styles from './publishing-list-item-thumbnail.module.scss';
import type {PublishingListItemThumbnailProps} from './publishing-list-item-thumbnail.types';

export function PublishingListItemThumbnail({...props}: PublishingListItemThumbnailProps): ReactElement<any> {
  const {iconName, thumbNailType, imgSrc, iconType, flatIconType, customThumbnailClasses = ''} = props;
  const [isLoading, setIsLoading] = useState(true);
  const handleImageLoad = (): void => {
    setIsLoading(false);
  };
  const handleImageError = (): void => {
    setIsLoading(false);
  };

  return (
    <div className={`${customThumbnailClasses} flexbox align-items-center radius-8`}>
      {thumbNailType === ThumbNailType.ICON ? (
        <Thumbnail
          data={{icon: iconName, icon_type: iconType, flat_icon_type: flatIconType, type: ThumbnailType.ICON, icon_size: props.iconSize ?? IconSize.SIZE_ICON_24, IconShape: IconShape.CIRCLE}}
          className={`spacing-p-4 ${props.iconClasses}`}
        />
      ) : (
        <div className={`${styles.publishingOptionsImageDimensions} flex-center radius-8`}>
          {isLoading ? <CircularProgressLoader size={LOADER_SIZE.SMALL} color={LOADER_COLOR.DARK} classes="_unmargin" /> : null}
          <img
            src={getAssetUrl(imgSrc ?? '')}
            onLoad={handleImageLoad}
            onError={handleImageError}
            className={`${styles.publishingOptionsImageDimensions} ${isLoading ? 'hidden' : ''}`} // Hide image while loading
            alt="Thumbnail"
          />
        </div>
      )}
    </div>
  );
}
